import { createAsyncThunk } from '@reduxjs/toolkit'
import { SecurityUsersServerData } from '@lk/api'

import { actions as LKActions } from '../../../features/shared/LKModal'
import { ThunkApi } from '../../index.d'

export const loadSecurityUsers = createAsyncThunk<SecurityUsersServerData, void, ThunkApi>(
  '[SECURITY] LOAD_SECURITY_USERS',
  async (_, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.security.users()

    if (result.success) {
      return result.data
    }

    dispatch(LKActions.openError(result.error.message))

    return rejectWithValue(result.error.message)
  },
)
